import React, { FunctionComponent } from 'react';

import callOutImgSrc from './assets/JG_Awards_Vote_2026.png';
import styles from './CallOut.module.scss';
import config from '../../config';

export const CallOut: FunctionComponent = () => {
  return (
    <section className={styles.callOut}>
      <div className={`container ${styles.container}`}>
        <div className={`jg-space-mtsm ${styles.callOutWrapper}`}>
          <div className={`jg-display-ib ${styles.content}`}>
            <h2 className={`jg-display-ib jg-space-ptmd ${styles.header}`}>
              Voting now open for the 2026 JustGiving Awards
            </h2>
            <p className={`jg-display-ib ${styles.description} jg-space-mtsm`}>
              Vote now for your favourite fundraising heroes in the 2026
              JustGiving Awards. Read their stories and get inspired.
            </p>

            <div className={`jg-space-mtsm ${styles.buttonWrapper}`}>
              <a
                className={`jg-btn--ghost jg-space-mbm ${styles.button}`}
                href={config.jgAwardsVoteUrl}
              >
                Vote now
              </a>
            </div>
          </div>

          <div className={`jg-display-ib ${styles.content} jg-flex-asc`}>
            <a href={config.jgAwardsVoteUrl} tabIndex={-1} aria-hidden>
              <img
                src={callOutImgSrc}
                alt="Nominate now"
                className={`jg-space-psm callOut-img ${styles.callOutImg}`}
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
